export function languageFromPath(path) {
  if (!path) return 'fi';

  if (path.startsWith('/ru')) return 'ru';
  else return 'fi';
}

export default languageFromPath;